import { shallowMount } from "@vue/test-utils";
import AddressData from "@/mixins/address-data";
import Vuex from "vuex";

describe("AddressData Component", () => {
  let Component;
  let wrapper;

  beforeEach(() => {
    new Vuex.Store({
      getters: {
        getLocalidadesAgregadasByProv: jest.fn(() => [])
      }
    });
    const addresDataMock = {
      calle: "",
      codigoPostal: "",
      dpto: "",
      lineas: [],
      localidad: "",
      numero: "",
      piso: "",
      provincia: "",
      codProv: "",
      localid: ""
    };
    Component = {
      render() {},
      mixins: [AddressData],
      props: {
        value: {
          type: Object,
          required: true
        }
      }
    };
    wrapper = shallowMount(Component, {
      propsData: {
        value: addresDataMock
      }
    });
    // Mock console.error
    jest.spyOn(console, "error").mockImplementation(() => {});
  });

  afterEach(() => {
    // Restore the original console.error
    console.error.mockRestore();
  });

  it("Renders the AddressData component", () => {
    expect(wrapper).toBeDefined();
  });

  it("Should set the default values correctly", () => {
    expect(wrapper.vm.value).toEqual({
      calle: "",
      codigoPostal: "",
      dpto: "",
      lineas: [],
      localidad: "",
      numero: "",
      piso: "",
      provincia: "",
      codProv: "",
      localid: ""
    });
  });
});
